module.exports = __webpack_public_path__ + "media/assets/icons/ic-menu-1af45ae4c36fc75f160570cc119291aa.svg";